import { formatJalaliDate, formatJalaliYear } from "./dateFormat";
// Modern A4 Purchase Return Invoice Printing
export const printPurchaseReturn = (purchaseReturn) => {
  const printWindow = window.open('', '_blank');
  
  const currencySymbol = purchaseReturn.purchase_details?.currency_details?.symbol || 
                        purchaseReturn.purchase_details?.currency_details?.title || 'AF';
  
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return formatJalaliDate(date);
  };

  const calculateTotalRefund = () => {
    return purchaseReturn.return_items?.reduce((sum, item) => {
      const val = item.calculated_refund_amount?.parsedValue ?? 
                  parseFloat(item.refund_amount) ?? 0;
      return sum + val;
    }, 0).toFixed(2) || "0.00";
  };

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Purchase Return Invoice</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
          background: white;
        }
        .invoice {
          max-width: 210mm;
          margin: 0 auto;
          padding: 20mm;
          background: white;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          padding-bottom: 20px;
          border-bottom: 3px solid #ff9800;
        }
        .company-info {
          flex: 1;
        }
        .company-name {
          font-size: 28px;
          font-weight: bold;
          color: #ff9800;
          margin-bottom: 5px;
        }
        .company-contact {
          color: #666;
          font-size: 14px;
        }
        .invoice-info {
          text-align: right;
          flex: 1;
        }
        .invoice-title {
          font-size: 32px;
          font-weight: bold;
          color: #ff9800;
          margin-bottom: 10px;
        }
        .invoice-number {
          font-size: 18px;
          color: #666;
        }
        .details-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        }
        .detail-box {
          background: #fff8e1;
          padding: 20px;
          border-radius: 8px;
          flex: 1;
          margin: 0 10px;
          border-left: 4px solid #ff9800;
        }
        .detail-box:first-child { margin-left: 0; }
        .detail-box:last-child { margin-right: 0; }
        .detail-title {
          font-weight: bold;
          color: #ff9800;
          margin-bottom: 10px;
          font-size: 16px;
        }
        .detail-content {
          color: #666;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 30px;
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .items-table th {
          background: #ff9800;
          color: white;
          padding: 15px;
          text-align: left;
          font-weight: 600;
        }
        .items-table td {
          padding: 15px;
          border-bottom: 1px solid #eee;
        }
        .items-table tr:hover {
          background: #fff8e1;
        }
        .items-table tr:last-child td {
          border-bottom: none;
        }
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        .summary-section {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 30px;
        }
        .summary-box {
          background: #fff8e1;
          padding: 25px;
          border-radius: 8px;
          min-width: 300px;
          border-left: 4px solid #ff9800;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          padding: 5px 0;
        }
        .summary-row.total {
          border-top: 2px solid #ff9800;
          padding-top: 15px;
          margin-top: 15px;
          font-weight: bold;
          font-size: 18px;
          color: #ff9800;
        }
        .reason-section {
          background: #fff8e1;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
          border-left: 4px solid #ff9800;
        }
        .reason-title {
          font-weight: bold;
          color: #ff9800;
          margin-bottom: 10px;
          font-size: 16px;
        }
        .footer {
          text-align: center;
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          color: #666;
        }
        .thank-you {
          font-size: 18px;
          font-weight: bold;
          color: #ff9800;
          margin-bottom: 10px;
        }
        @media print {
          body { margin: 0; padding: 0; }
          .invoice { 
            box-shadow: none; 
            max-width: none;
            padding: 15mm;
          }
          @page { 
            size: A4; 
            margin: 0;
          }
        }
      </style>
    </head>
    <body>
      <div class="invoice">
        <!-- Header -->
        <div class="header">
          <div class="company-info">
            <div class="company-name">شرکت تجارتی توکل نورزی</div>
            <div class="company-contact">
              📞 0700000371 - 0787700045<br>
              📧 wahidtajzoi737@gmail.com
            </div>
          </div>
          <div class="invoice-info">
            <div class="invoice-title">PURCHASE RETURN</div>
            <div class="invoice-number">#${purchaseReturn.id}</div>
          </div>
        </div>

        <!-- Details Section -->
        <div class="details-section">
          <div class="detail-box">
            <div class="detail-title">Supplier:</div>
            <div class="detail-content">
              <strong>${purchaseReturn.purchase_details?.supplier_details?.name || 'Unknown Supplier'}</strong><br>
              ${purchaseReturn.purchase_details?.supplier_details?.phone || ''}<br>
              ${purchaseReturn.purchase_details?.supplier_details?.address || ''}
            </div>
          </div>
          <div class="detail-box">
            <div class="detail-title">Branch Details:</div>
            <div class="detail-content">
              <strong>Branch:</strong> ${purchaseReturn.shop_details?.name || 'Unknown Branch'}<br>
              <strong>Return Date:</strong> ${formatDate(purchaseReturn.return_date || purchaseReturn.created_at)}<br>
              <strong>Original Purchase:</strong> #${purchaseReturn.purchase || purchaseReturn.purchase_details?.id || 'N/A'}<br>
              <strong>Purchase Date:</strong> ${formatDate(purchaseReturn.purchase_details?.purchase_date)}<br>
              <strong>Items Returned:</strong> ${purchaseReturn.return_items?.length || 0}
            </div>
          </div>
        </div>

        <!-- Reason Section -->
        ${purchaseReturn.reason ? `
        <div class="reason-section">
          <div class="reason-title">Return Reason:</div>
          <div class="detail-content">${purchaseReturn.reason}</div>
        </div>
        ` : ''}

        <!-- Items Table -->
        <table class="items-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th class="text-center">Return Qty</th>
              <th class="text-right">Purchase Price</th>
              <th class="text-right">Refund Amount</th>
              <th class="text-center">Return Date</th>
            </tr>
          </thead>
          <tbody>
            ${purchaseReturn.return_items && purchaseReturn.return_items.length > 0 ? 
              purchaseReturn.return_items.map((item, index) => {
                const name = item.purchase_item_details?.product_details?.name || 
                           item.purchase_item_details?.product?.name || 
                           `Product ${index + 1}`;
                const qty = item.return_quantity;
                const purchasePrice = parseFloat(item.purchase_item_details?.buy_price || 
                                               item.purchase_item_details?.purchase_price || 0).toFixed(2);
                const refundAmount = (item.calculated_refund_amount?.parsedValue ?? 
                                   parseFloat(item.refund_amount) ?? 0).toFixed(2);
                const returnDate = formatDate(item.created_at);
                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td><strong>${name}</strong></td>
                    <td class="text-center">${qty}</td>
                    <td class="text-right">${purchasePrice} ${currencySymbol}</td>
                    <td class="text-right"><strong>${refundAmount} ${currencySymbol}</strong></td>
                    <td class="text-center">${returnDate}</td>
                  </tr>
                `;
              }).join('')
              : '<tr><td colspan="6" class="text-center">No items found</td></tr>'
            }
          </tbody>
        </table>

        <!-- Summary Section -->
        <div class="summary-section">
          <div class="summary-box">
            <div class="summary-row total">
              <span>Total Refund Amount:</span>
              <span>${calculateTotalRefund()} ${currencySymbol}</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer">
          <div class="thank-you">Thank you for your understanding!</div>
          <div>© ${formatJalaliYear()} شرکت تجارتی توکل نورزی - All rights reserved</div>
          <div style="margin-top:4px;font-size:10px;color:#999;">Powered by Afghan Cosmos IT Solutions </div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 1000);
        };
      </script>
    <div style="margin-top:12px;text-align:center;font-size:11px;color:#6b7280;">Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com</div></body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
};

export default { printPurchaseReturn };

